import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./base-query";

const chatAPI = createApi({
    reducerPath: "chatAPI",
    baseQuery,
    endpoints: (builder) => ({
        getChatCredentials: builder.query({
            query: () => {
                return {
                    url: `/chat/token`,
                    method: 'GET',
                };
            },
            transformResponse: (response) => response,
            providesTags: ['chatCredentials']
        }),

        getChatList: builder.mutation({
            query: ({
                type,
                page, 
                size,
                searchTerm
            }) => {
                const params = new URLSearchParams();

                params.append('type', type);
                params.append('page', page);
                params.append('limit', size);
                
                if(searchTerm) params.append('search', searchTerm);

                return {
                    url: `/chat/active-contacts?${params.toString()}`,
                    method: 'GET',
                };
            },
            transformResponse: (response) => response,
            providesTags: ['chatList']
        }),

        getChannelMembers: builder.mutation({
            query: ({channelId}) => {
                return {
                    url: `/chat/channels/${channelId}/members`,
                    method: 'GET',
                };
            },
            transformResponse: (response) => response
        }),
        
        createNewChat: builder.mutation({
            query: ({body}) => ({
                url: `/chat/vendor-channel`,
                method: "POST",
                body: body
            }),
            transformResponse: (response) => response,
            invalidatesTags: ['chatList']
        }),
        createSupportChat: builder.mutation({
            query: ({body}) => ({
                url: `/chat/support-channel`,
                method: "POST",
                body: body
            }),
            transformResponse: (response) => response
        }),

        getBookingsByChatUser: builder.mutation({
            query: ({ targetPersonId, page = 1, limit = 10 }) => ({
                url: `/bookings/user/${targetPersonId}?page=${page}&limit=${limit}`,
                method: "GET",
            }),
        }),
    })
});

export const { 
    useGetChatCredentialsQuery,

    useGetChatListMutation,

    useGetChannelMembersMutation,

    useCreateNewChatMutation,
    useCreateSupportChatMutation,

    useGetBookingsByChatUserMutation,
} = chatAPI;

export default chatAPI;